export const filterItems = (items: string[], query: string) =>
  items.filter(item => item.toLowerCase().includes(query.toLowerCase()));
